export enum ListDeleteBehavior {

    /**
     * Remove the record from the list and notify the user.
     */
    Default = "DEFAULT",

    /**
     * Remove the record from the list, notify the user, then scroll to the position the
     * record occupied so the surrounding rows stay in view.
     *
     * The list state tracks the 0-n position of every rendered row by id (see
     * `setRowPositions`), so this works on both cached and uncached lists. When the deleted
     * record was the last row the scroll lands on the new last row; when the list empties
     * no scroll occurs.
     */
    ScrollToSpot = "SCROLL_TO_SPOT"
}
